import React, { useRef, useEffect } from 'react'

const VolumeMeter = ({ userMedia }) => {
  const canvas = useRef<any>(null)
  const canvasContext = useRef<any>(null)

  useEffect(() => {
    canvasContext.current = canvas.current.getContext('2d')
  }, [])

  const mediaStreamTracks = userMedia.current.getAudioTracks()

  if (mediaStreamTracks.length) {
    const audioContext = new AudioContext()
    const analyser = audioContext.createAnalyser()
    const microphone = audioContext.createMediaStreamSource(userMedia.current)
    const javascriptNode = audioContext.createScriptProcessor(2048, 1, 1)

    analyser.smoothingTimeConstant = 0.8
    analyser.fftSize = 1024

    microphone.connect(analyser)
    analyser.connect(javascriptNode)
    javascriptNode.connect(audioContext.destination)

    javascriptNode.onaudioprocess = () => {
      var array = new Uint8Array(analyser.frequencyBinCount)
      analyser.getByteFrequencyData(array)
      var values = 0

      var length = array.length
      for (var i = 0; i < length; i++) {
        values += array[i]
      }

      var average = values / length

      canvasContext.current.clearRect(0, 0, 300, 300)
      canvasContext.current.fillStyle = '#5cb85c'
      canvasContext.current.fillRect(0, 0, average * 3, 10)
      canvasContext.current.fillStyle = '#262626'
    }
  }

  return <canvas ref={canvas} id="canvas" width="300" height="10"></canvas>
}

export default VolumeMeter
